<template>
  <div class="flex flex-col gap-3">
    <div>
      <Label for="pet-name">Nom de l'animal</Label>
      <Input id="pet-name" v-model="name" class="w-64" />
    </div>
    <div>
      <Label for="pet-category">Type de l'animal
        <Required />
      </Label>
      <Select id="pet-category" v-model="categoryId">
        <SelectTrigger class="w-64">
          <SelectValue placeholder="Sélectionnez un type" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem
            v-for="category in categories"
            :key="category.id"
            :value="category.id.toString()"
          >
            {{ category.name }}
          </SelectItem>
        </SelectContent>
      </Select>
    </div>
  </div>
</template>

<script lang="ts" setup>
import {onMounted, ref} from "vue";
import {PetCategory} from "@/customer/interfaces/Pet";
import {Input} from "@/core/components/ui/input";
import {Label} from "@/core/components/ui/label";
import {Select, SelectContent, SelectItem, SelectTrigger, SelectValue} from "@/core/components/ui/select";
import Required from "@/core/components/forms/Required.vue";
import {petApi} from "@/container";

/** The pet name, optional. */
const name = defineModel<string | undefined>('name');
/** The selected category id, as the select handles it: a string. */
const categoryId = defineModel<string | undefined>('categoryId');

const categories = ref<PetCategory[]>([]);

onMounted(async () => {
    categories.value = await petApi().categories();
});
</script>
